import styles from './index.module.scss';
import { useState } from 'react';
import logo from '../../assets/images/img-navbar-logo.png';
import close from '../../assets/icons/burger-menu-close.svg';
import menu from '../../assets/icons/burger-menu-btn.svg';
import { useNavigate } from 'react-router-dom';

export default function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();

  const handleToogleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  }
  const handleGoToRegister = () => {
    setIsMenuOpen(false)
    navigate('/register')
  }

  return (
    <nav className={styles['navbar']}>
      <div className={styles['navbar-logo']}>
        <img onClick={() => navigate('/')} className={styles['navbar-logo-icon']} src={logo} alt='Logo' />
      </div>
      <ul className={styles['navbar-links']}>
        <li onClick={() => navigate('/#summer-program')} className={styles['navbar-link']}>Summer Program</li>
        <li onClick={() => navigate('/about-big-ramy')} className={styles['navbar-link']}>About Big Ramy</li>

        <li className={styles['navbar-menu-link']}>
          <a href="/register">Register</a>
        </li>
      </ul>
      <button className={styles['navbar-menu-action']} onClick={handleToogleMenu}>
        <img src={menu} alt='Menu'></img>
      </button>
      {
        isMenuOpen && (
          <div className={styles['navbar-menu']}>
            <img src={close} onClick={handleToogleMenu} className={styles['navbar-menu-close']} alt='' />
            <ul className={styles['navbar-menu-links']}>
              <li onClick={() => navigate('/#summer-program')} className={styles['navbar-link']}>Summer Program</li>
              <li onClick={() => navigate('/about-big-ramy')} className={styles['navbar-link']}>About Big Ramy</li>
              <li className={styles['navbar-link']}>
                <a href="/register">Register</a>
              </li>
            </ul>
          </div>
        )
      }
    </nav>
  )
}
